const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

async function req(path, options = {}) {
  const res = await fetch(`${BACKEND_URL}/api${path}`, {
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    ...options,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.detail || `Request failed (${res.status})`);
  return data;
}

export const workPlannerApi = {
  createPlan: (payload) => req(`/work-planner/plans`, { method: "POST", body: JSON.stringify(payload) }),
  listPlans: (params = {}) => req(`/work-planner/plans?${new URLSearchParams(params).toString()}`),
  getPlan: (id) => req(`/work-planner/plans/${id}`),
  cancelPlan: (id) => req(`/work-planner/plans/${id}/cancel`, { method: "POST" }),
  listActivities: (params = {}) => req(`/work-planner/activities?${new URLSearchParams(params).toString()}`),
  clientMonthlyStats: (clientId, year, month) => req(`/work-planner/client-stats/${clientId}?year=${year}&month=${month}`),
  dashboardStats: () => req(`/work-planner/dashboard-stats`),
  clientTaskSummary: (params = {}) => req(`/work-planner/client-task-summary?${new URLSearchParams(params).toString()}`),
  listTags: (params = {}) => req(`/client-tags?${new URLSearchParams(params).toString()}`),
  createTag: (payload) => req(`/client-tags`, { method: "POST", body: JSON.stringify(payload) }),
  updateTag: (id, payload) => req(`/client-tags/${id}`, { method: "PUT", body: JSON.stringify(payload) }),
  deleteTag: (id) => req(`/client-tags/${id}`, { method: "DELETE" }),

  // Planner task CRUD — raw-write endpoints that preserve all 5 planner
  // statuses (the shared /api/tasks/enhanced path coerces unknown statuses).
  createTask: (payload) => req(`/work-planner/tasks`, { method: "POST", body: JSON.stringify(payload) }),
  updateTask: (taskId, patch) => req(`/work-planner/tasks/${taskId}`, { method: "PATCH", body: JSON.stringify(patch) }),
  deleteTask: (taskId) => req(`/work-planner/tasks/${taskId}`, { method: "DELETE" }),
};

// Shared planner status vocabulary + display mapping (covers legacy CRM values
// so tasks created elsewhere still render sensibly in the planner).
export const PLANNER_STATUSES = [
  { value: "pending", label: "Pending", chip: "bg-slate-100 text-slate-700 ring-slate-200", dot: "bg-slate-400" },
  { value: "in_progress", label: "In Progress", chip: "bg-blue-100 text-blue-700 ring-blue-200", dot: "bg-blue-500" },
  { value: "completed", label: "Completed", chip: "bg-green-100 text-green-700 ring-green-200", dot: "bg-green-500" },
  { value: "on_hold", label: "On Hold", chip: "bg-amber-100 text-amber-700 ring-amber-200", dot: "bg-amber-500" },
  { value: "cancelled", label: "Cancelled", chip: "bg-rose-100 text-rose-700 ring-rose-200", dot: "bg-rose-500" },
];

const STATUS_ALIASES = {
  to_do: "pending", todo: "pending", pending: "pending",
  doing: "in_progress", in_progress: "in_progress",
  review: "in_progress", pending_approval: "in_progress",
  done: "completed", completed: "completed",
  on_hold: "on_hold", cancelled: "cancelled", canceled: "cancelled",
};
export const normalizePlannerStatus = (s) => STATUS_ALIASES[String(s || "").toLowerCase()] || "pending";
export const plannerStatusMeta = (s) => PLANNER_STATUSES.find((x) => x.value === normalizePlannerStatus(s)) || PLANNER_STATUSES[0];

export const PLANNER_PRIORITIES = [
  { value: "low", label: "Low", dot: "bg-slate-400" },
  { value: "medium", label: "Medium", dot: "bg-yellow-500" },
  { value: "high", label: "High", dot: "bg-orange-500" },
  { value: "urgent", label: "Urgent", dot: "bg-red-500" },
];
